import type { TOC } from '@ember/component/template-only';
import { or } from 'tio-ui/utilities';
import { PhWarning } from 'ember-phosphor-icons';
export interface DetailWithIconArgs {
  Args: {
    icon?: unknown;
    detail?: string;
    iconBgColor?: string;
  };
  Element: HTMLElement;
}

const DetailWithIcon: TOC<DetailWithIconArgs> = <template>
  <div class="tio-row-flush m-4">
    <div
      class="flex grow-0 shrink-0 justify-center items-center w-12 h-12 mr-[10px] rounded-full
        {{or @iconBgColor 'tio-bg-neutral'}}"
    >
      <div class="h-6 tio-fg-inverse">
        {{#if @icon}}
          <@icon @size="16" />
        {{else}}
          <PhWarning @size="16" />
        {{/if}}
      </div>
    </div>
    <div class="tio-fg-disabled">
      {{@detail}}
    </div>
  </div>
</template>;

export default DetailWithIcon;
